import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';

// "Is Code Bundle" column: read-only checkbox for the is_code_bundle boolean, shown once per code.
// Bundle parents also get an expand/collapse control; when onToggle is omitted it's display-only.
const BundleIndicatorField = ({ isBundleParent, show, isExpanded = false, onToggle }) => {
    const canExpand = show && isBundleParent && typeof onToggle === 'function';

    return (
        <td
            className="col col-medium border-right border-dark py-3"
            style={{ verticalAlign: 'middle', textAlign: 'center' }}>
            {show && (
                <span className="d-inline-flex align-items-center justify-content-center">
                    <input
                        type="checkbox"
                        checked={!!isBundleParent}
                        readOnly
                        onClick={(e) => e.preventDefault()}
                        title={isBundleParent ? 'Is a code bundle' : 'Not a code bundle'}
                        style={{ width: '16px', height: '16px', cursor: 'default' }}
                    />
                    {canExpand && (
                        <span
                            role="button"
                            className="bundle-toggle ml-2"
                            title={isExpanded ? 'Hide child codes' : 'Show child codes'}
                            aria-label={isExpanded ? 'Hide child codes' : 'Show child codes'}
                            aria-expanded={isExpanded}
                            onClick={onToggle}
                            style={{ cursor: 'pointer' }}>
                            <FontAwesomeIcon icon={isExpanded ? faChevronDown : faChevronRight} />
                        </span>
                    )}
                </span>
            )}
        </td>
    );
};

export default BundleIndicatorField;
